import React from 'react';
import {env} from "@config/env.ts";
import useAuth0 from "@common/Auth0Provider/use-auth0.ts";

const Index = () => {
    const INACTIVITY_TIMEOUT = parseFloat(env.idealLogoutMinutes ? env.idealLogoutMinutes : "30") * 60 * 1000;
    const {logout} = useAuth0();

    // Update last activity timestamp on user interaction
    const updateLastActivity = () => {
        console.log('Updating last activity timestamp');
        localStorage.setItem('lastActivity', Date.now().toString());
        navigator.serviceWorker.getRegistrations().then(registrations => {
            registrations.forEach(registration => {
                if(registration.active)
                    registration.active.postMessage({ type: 'activity', timestamp: Date.now() })
            })
        })
    }

    // Attach event listeners for user activity
    const monitorUserActivity = () => {
        // Events you'd like to track:
        ['click', 'scroll', 'touchstart'].forEach((event) => {
            window.addEventListener(event, updateLastActivity);
        });
    }

    // Check inactivity on app resume
    const checkInactivityOnResume = () => {
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                const lastActivity = parseInt(localStorage.getItem('lastActivity'), 10);
                const now = Date.now();

                // If no activity in the last 30 minutes, log out the user
                if (lastActivity && ((now - lastActivity) > INACTIVITY_TIMEOUT)) {
                    console.log('User has been inactive for 30+ minutes. Logging out...');
                    logout({
                        logoutParams: {
                            returnTo: window.location.origin,
                        },
                    });
                }
            }
        });
    }
    

    React.useEffect(() => {
        // Initialize user activity tracking
        monitorUserActivity();

        // Update the last activity when the page is loaded
        updateLastActivity();

        // Check inactivity when the app resumes
        checkInactivityOnResume();

    }, [])

    return (
        <>

        </>
    );
};

export default Index;